import { useEffect } from '../../InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss} from '../../CommonImports';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import './../css/GLayOutSpacing.css';
import './../css/GAnimetion.css';
import './../css/GAboutUs.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import GHeader from "./GHeader";
import GFooter from "./GFooter";
import GJobsHubMenu from './GJobsHubMenu';
import GSignImg from './GSignImg';
import GJobAnimetedAboutUs from './GJobAnimetedAboutUs';
import GJobAboutCard from './GJobAboutCard';
import GJobAboutFindJob from './GJobAboutFindJob';
import GJobAboutTeam from './GJobAboutTeam';


function GJobAboutUs() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <GHeader />
            <GJobsHubMenu />
            <GJobAnimetedAboutUs/>
            <GJobAboutCard/>
            <GJobAboutFindJob/>
            <GJobAboutTeam/>

            <section className="section-box my-5">
                <GSignImg />
            </section>
            <GFooter />
        </div>
    );
}
export default GJobAboutUs;